export default "__VITE_ASSET__CgrHU0NN__"